import React, { useState, useContext } from "react";
import { LangCtx } from "../../../../lib/context";
// import "../Styles.css";
// import "./doctorUploadsStyles.css";
import "../../../../ui-styles/animations/ripple.css";
import "../../../../ui-styles/buttons/ButtonFilled.css";
import "../../../../ui-styles/buttons/ButtonTxt.css";
import "../../../../ui-styles/buttons/IconButton.css";
import "../../../../ui-styles/list/ListAutoUnderLine.css";
import "../../../../ui-styles/search/Search.css";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import BtmDeleteSlide from "../../../../lib/ui/BtmDeleteSlider";
import UploadFileView from "./uploadFileView";

const SlideUploadFilesListItem = (props) => {
    const { l } = useContext(LangCtx);
    // const { setFileView } = useContext(FileCtx);
    const [selFile, setFileView] = useState(null);
    const [slideD, setSlideD] = useState(false);
    const validExtensions = ["jpg", "jpeg", "png", "gif"];
    const { file } = props;

    const handleDownload = (url, data) => {
        const fileUrl = data.url;
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = data.downloadname; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    

    const handleView = () => {
        if(file?.url){
            const fileType = file.url.split(".").pop().toLowerCase();
            if (fileType === "xlsx" || fileType === "xls") {
                handleDownload(file.url);
            }else{
                setFileView(file);
            }
        }
    };


    return (
        <>
            <li className="atmntItem" key={file.id} onClick={handleView}>
                <div className="atmntIconBox">
                    {/* <img src={`/images/file-icons/${file.uploadtype === "youtubeUrl" ? 'youtube' : file.uploadkey ? file.uploadkey.split('.').pop() : 'blank-file.png'}`} alt="avatar" /> */}
                    <img
                        src={`/images/file-icons/${
                            file.uploadtype === "youtubeUrl"
                                ? "youtube"
                                : file?.uploadkey && validExtensions.includes(file.uploadkey.split(".").pop().toLowerCase())
                                ? file.uploadkey.split(".").pop()
                                : "blank"
                        }-file.png`}
                        alt="avatar"
                    />

                </div>
                <div className="atmntTxtBox">
                    <span className="atmntTxt">{file.uploadkey && file.uploadkey.substr(14)}</span>
                </div>
                <ArrowForwardIosIcon className="atmntIcon" />
                {/* <div className="admntAnciton"></div> */}
            </li>
            {slideD && (
                <BtmDeleteSlide
                    slideD={slideD}
                    handleCancel={() => setSlideD((prevState) => !prevState)}
                    txt={l.conf_del}
                    handleConfirm={() => props.deleteDocument(file)}
                />
            )}
            {selFile !== null && <UploadFileView open={selFile !== null} handleClose={() => setFileView(null)} data={selFile} />}
        </>
    );
};

export default SlideUploadFilesListItem;
